// Helper to derive provider display values (payout, commission, currency)
export const getProviderDisplayValues = transaction => {
  const protectedData = transaction?.attributes?.protectedData || {};
  const manual = protectedData?.manualProviderPayoutMetadata || protectedData?.manualPayoutMetadata || null;
  const subtotal = protectedData?.subtotal || null; // { amount, currency }
  const lineItems = transaction?.attributes?.lineItems || [];
  const payoutTotal = transaction?.attributes?.payoutTotal || null;
  
  console.log('[PROVIDER UI] RAW DATA RECEIVED:', {
    transactionId: transaction?.id?.uuid,
    hasProtectedData: !!protectedData,
    protectedDataKeys: Object.keys(protectedData),
    hasManualMeta1: !!protectedData?.manualProviderPayoutMetadata,
    hasManualMeta2: !!protectedData?.manualPayoutMetadata,
    manualMeta: manual,
    subtotal: subtotal,
    payoutTotal: payoutTotal
  });

  // Check if transaction has been fully refunded (has reversal line items)
  const hasReversals = lineItems.some(item => item.reversal === true);
  
  let providerPayoutAmount = null;
  let originalPayoutAmount = null; // Store original amount for commission calculation
  let currency = payoutTotal?.currency || subtotal?.currency || 'CHF';

  // Determine the original payout amount (before refund)
  if (manual && typeof manual.providerPayoutAmount === 'number') {
    originalPayoutAmount = manual.providerPayoutAmount;
    providerPayoutAmount = manual.providerPayoutAmount;
  } else if (payoutTotal && typeof payoutTotal.amount === 'number') {
    originalPayoutAmount = payoutTotal.amount;
    providerPayoutAmount = payoutTotal.amount;
  } else {
    // fallback: session unitPrice
    const sessionLine = lineItems.find(item => item.code && item.code.startsWith('line-item/session') && (!item.includeFor || item.includeFor.includes('provider')));
    originalPayoutAmount = sessionLine?.unitPrice?.amount ?? 0;
    providerPayoutAmount = originalPayoutAmount;
    currency = sessionLine?.unitPrice?.currency || currency;
  }

  // If transaction is refunded, the DISPLAY payout is 0
  if (hasReversals) {
    providerPayoutAmount = 0;
  }

  // Commission amount calculation:
  // For manual payout scenarios (requiresManualPayout=true), the provider commission is -100%
  // in line items, but the ACTUAL commission should be calculated from subtotal
  let commissionAmount = null;
  
  console.log('[PROVIDER UI DEBUG] Full transaction data:', {
    hasManual: !!manual,
    requiresManualPayout: manual?.requiresManualPayout,
    manualProviderPayoutAmount: manual?.providerPayoutAmount,
    subtotal: subtotal,
    payoutTotal: payoutTotal,
    hasReversals,
    providerPayoutAmountCalculated: providerPayoutAmount,
    originalPayoutAmount
  });
  
  if (manual && manual.requiresManualPayout) {
    // Manual payout case: Use the REAL commission directly from metadata
    // No calculation needed - it's already stored correctly
    
    // SIMPLE FIX: Use realProviderCommission if available, otherwise calculate
    if (typeof manual.realProviderCommission === 'number') {
      commissionAmount = manual.realProviderCommission; // Already in cents, already negative
      console.log('[PROVIDER UI] Manual payout commission (from metadata):', {
        commission: commissionAmount,
        currency
      });
    } else {
      // Fallback calculation if metadata doesn't have it
      const subtotalAmount = manual.realSubtotal ?? subtotal?.amount ?? 0;
      commissionAmount = (originalPayoutAmount ?? 0) - subtotalAmount;
      console.log('[PROVIDER UI] Manual payout commission (calculated):', {
        subtotal: subtotalAmount,
        originalPayout: originalPayoutAmount,
        commission: commissionAmount,
        currency
      });
    }
  } else {
    // Normal case: read directly from line items (most reliable source)
    const providerCommissionLine = lineItems.find(item => item.code === 'line-item/provider-commission' && !item.reversal);
    commissionAmount = providerCommissionLine?.lineTotal?.amount ?? 0;
    
    console.log('[PROVIDER UI] Normal commission from line items:', {
      commissionAmount,
      currency,
      foundLine: !!providerCommissionLine
    });
  }

  return {
    providerPayoutAmount,
    commissionAmount,
    currency,
    subtotalAmount: subtotal?.amount ?? null,
    requiresManualPayout: manual?.requiresManualPayout || false, // Add flag for debugging
  };
};

export default getProviderDisplayValues;
